export default __webpack_public_path__ + "media/images/icons/personal-info-ef96f941cce69351a4b1039b5b423f2f.svg";